import { polygonSteelType, roundSteelType } from "../../../constants/rebar-constants";

export const rebarProfiles = [polygonSteelType, roundSteelType];

// Keep the diameter size when it is compatible with the selected profile.
// Select records from the same catalog used by the desktop editor.
export function selectProfile(shape: any, value: string, catalog: any) {
  const profile = Number(value);
  if (!rebarProfiles.includes(profile)) return shape;
  const options = catalog[profile] || [];
  const diameter = options.find((item: any) =>
    Number(item.steel_diameter) === Number(shape.diameter?.steel_diameter)
  ) || options[0] || null;
  const length = (shape.rebar_side || []).reduce(
    (sum: number, side: any) => sum + Number(side.length || 0), 0
  );
  return {
    ...shape,
    steel_type: profile,
    diameter,
    unit_weight: diameter ? (length / 100 * Number(diameter.weight)).toFixed(2) : "0.00",
  };
}
